import { SuperAdminConstants } from '../../../_constants';

const initialState = { addAssignMetricLoading: true, data: '', error: false };

export function addAssignMetricListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_ADD_NEW_METRIC:
            return {
                addAssignMetricListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ADD_NEW_METRIC:
            return {
                addAssignMetricListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.ADD_NEW_METRIC_ERROR:
            return {
                addAssignMetricListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignMetric/addNewCompetencyAssignMetric.reducer.js